export const AuthConfig = {
    githubAccessToken: "/Auth/GetGithubAccessToken",
    getGoogleUserProfile:"/Auth/GetGoogleUserProfile"
  };